$gd_web_frame $mol_frame
	uri \https://web.giper.dev/#mol_lights={lights}/current={current}/query={query}
	- uri \http://localhost:9080/gd/web/bar/-/test.html#mol_lights={lights}/current={current}/query={query}
	query \
